import { MarketingTotal } from '../metrics/marketingTotal';
import { CompanyConfigurationDto } from './companyConfiguration.model';

export class Company {
  id: string;
  name: string;
  marketingTotals: MarketingTotal;
  companyConfiguration?: CompanyConfigurationDto;
}
